import { useMutation } from 'react-query';
import request from '../../../../helpers/request';

function changeDate({ acceptanceId, date, config }) {
  return request.post(
    `Acceptance/${config.endPoint}`,
    undefined,
    'Не удалось изменить дату',
    'Error',
    undefined,
    { acceptanceId, [config.paramKey]: date }
  );
}

export const useAcceptanceDateMutation = (options) =>
  useMutation(changeDate, {
    ...options,
    onSuccess: (data, variables) => {
      if (data !== 'Error' && typeof options?.onSuccess === 'function') {
        options.onSuccess(data, variables);
      }
    },
  });
